module.exports = __webpack_public_path__ + "img/cloth_g3_sleeve-06.bacdff5e.svg";